import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedPolling } from '@eggplant/data-request'
import type { GetRunLogFiltersResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  interval?: number
  isPolling: boolean
  onSuccess: (data: GetRunLogFiltersResponse) => void
  children?: (data: GetRunLogFiltersResponse) => ReactElement
}

const PollAiRunLogFiltersRequest = ({
  id,
  interval = 1000,
  isPolling,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/runlogs/${id}/filters`

  return (
    <AuthenticatedPolling<GetRunLogFiltersResponse>
      children={children}
      intervalMs={interval}
      isPolling={isPolling}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default PollAiRunLogFiltersRequest
